import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Input, Btn, Spinner } from '../components/common/UI';
import toast from 'react-hot-toast';

export default function Register() {
  const [form, setForm] = useState({ username: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success('Admin registered!');
      navigate('/');
    } catch (err) {
      const d = err.response && err.response.data;
      const msg = (d && d.error) || (d && d.errors && d.errors[0] && d.errors[0].message) || 'Registration failed';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a' }}>
      <div style={{ width: 380, background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 32 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>💬</div>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: '#f1f5f9' }}>Register Admin</h1>
          <p style={{ color: '#f59e0b', fontSize: 12, marginTop: 4 }}>⚠ First admin registration only</p>
        </div>
        <form onSubmit={handle}>
          <Input
            label="Username"
            placeholder="admin"
            value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
            required
          />
          <Input
            label="Email"
            type="email"
            placeholder="admin@example.com"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />
          <Input
            label="Password"
            type="password"
            placeholder="Min 8 chars, letter + number"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
          />
          <Btn type="submit" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
            {loading ? <Spinner size={16} /> : 'Register'}
          </Btn>
        </form>
        <p style={{ textAlign: 'center', marginTop: 16, color: '#64748b', fontSize: 13 }}>
          Already have account?{' '}
          <Link to="/login" style={{ color: '#25d366' }}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}
